import { motion } from 'framer-motion'
import { Clock, ChevronDown } from 'lucide-react'
import { Button } from '../ui/Button'
import leaderboardService from '../../services/leaderboardService'

const LeaderboardFilters = ({ timeframe, onTimeframeChange, showFilters, onToggleFilters }) => {
  const timeframes = [
    { value: 'all', label: 'All Time' },
    { value: 'month', label: 'This Month' },
    { value: 'week', label: 'This Week' }
  ]

  return (
    <div className="relative">
      <Button
        variant="outline"
        onClick={onToggleFilters}
        className="flex items-center gap-2 bg-white/80 backdrop-blur-sm border-neutral-200 hover:bg-white"
      >
        <Clock className="w-4 h-4" />
        <span className="hidden sm:inline">
          {leaderboardService.getTimeframeDisplay(timeframe)}
        </span>
        <span className="sm:hidden">
          {timeframe === 'all' ? 'All' : timeframe === 'month' ? 'Month' : 'Week'}
        </span>
        <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${showFilters ? 'rotate-180' : ''}`} />
      </Button>

      {showFilters && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
          className="absolute top-full mt-2 right-0 bg-white rounded-lg shadow-lg border border-neutral-200 py-2 z-50 min-w-[140px]"
        >
          {timeframes.map((option) => (
            <button
              key={option.value}
              onClick={() => {
                onTimeframeChange(option.value)
                onToggleFilters()
              }}
              className={`w-full text-left px-4 py-2 hover:bg-neutral-50 transition-colors duration-150 ${
                timeframe === option.value
                  ? 'text-primary-teal font-medium bg-primary-teal/5'
                  : 'text-neutral-700'
              }`}
            >
              {option.label}
              {timeframe === option.value && (
                <span className="float-right text-primary-teal">✓</span>
              )}
            </button>
          ))}
        </motion.div>
      )}
    </div>
  )
}

export default LeaderboardFilters